import {
  createGlobalStyle,
} from 'styled-components';

import fonts from './fonts';

export const GlobalStyle = createGlobalStyle`
  ${fonts};
  a {
    color: ${props => props.theme.colors.link};
    text-decoration: none;
  }

  .rbc-overlay {
    max-height: 600px;
    overflow: auto;
  }

  // hide a notify when the tour or the modal is open
  .opened_tour .Toastify,
  .onboarding-video-open .Toastify {
    display: none;
  }

  .mobile-chat-container {
    left: 30px;
  }

  .input-text-center input {
    text-align: center;
  }
`;

export * as icons from './icons';
export * as SVG from './SVG';
export * as utils from './utils';
export * from './typography';
export * from './theme';
export * from './components';
